export enum InvoiceApi {
  search = '/invoice/search',
  searchItems = '/invoice/search/items',
  configuration = '/invoice/configuration'
}
